import { useEffect, useState } from "react";
import { TrendingUp, Radar, CalendarCheck } from "lucide-react";

const ACTIVITY = [
  { tag: "+12 SQLs", detail: "Manufacturing · this week", when: "just now" },
  { tag: "+8 SQLs", detail: "SaaS · UK & Benelux", when: "3 min ago" },
  { tag: "+15 SQLs", detail: "Financial Services", when: "5 min ago" },
  { tag: "+6 SQLs", detail: "Digital Manufacturing", when: "7 min ago" },
  { tag: "+21 SQLs", detail: "ICT & Telecoms · EMEA", when: "9 min ago" },
];

const WARMING = [
  { tag: "3 accounts", detail: "warming · Automotive", when: "live" },
  { tag: "5 accounts", detail: "warming · Industrial", when: "live" },
  { tag: "2 accounts", detail: "warming · Cloud & FinOps", when: "live" },
  { tag: "7 accounts", detail: "warming · Banking software", when: "live" },
  { tag: "4 accounts", detail: "warming · E-mobility", when: "live" },
];

const BOOKINGS = [
  { tag: "Latest", detail: "VP Growth · SBS", when: "8 min ago" },
  { tag: "Latest", detail: "CMO office · Diconium", when: "14 min ago" },
  { tag: "Latest", detail: "Head of Demand · Silverfin", when: "22 min ago" },
  { tag: "Latest", detail: "Director of Marketing · Outokumpu", when: "31 min ago" },
  { tag: "Latest", detail: "Chief of Staff · Proximus NXT", when: "44 min ago" },
];

const CELLS = [
  { key: "activity", icon: TrendingUp, label: "This week", items: ACTIVITY, hueClass: "text-teal", interval: 4200 },
  { key: "warming", icon: Radar, label: "In-market", items: WARMING, hueClass: "text-teal", interval: 5100 },
  { key: "booking", icon: CalendarCheck, label: "Booked", items: BOOKINGS, hueClass: "text-teal", interval: 6300 },
];

function Cell({ cell, cellIdx }) {
  const [i, setI] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setI((v) => (v + 1) % cell.items.length), cell.interval);
    return () => clearInterval(t);
  }, [cell.interval, cell.items.length]);

  const item = cell.items[i];
  const Icon = cell.icon;

  return (
    <div
      data-testid={`trust-ticker-cell-${cell.key}`}
      className="relative rounded-2xl border border-white/[0.06] bg-[#0A121A] p-4 md:p-5 card-hover overflow-hidden"
    >
      {/* subtle sweep */}
      <span
        aria-hidden
        className="absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-teal/10 to-transparent ticker-sweep"
        style={{ animationDelay: `${cellIdx * 0.7}s` }}
      />
      <div className="relative flex items-center gap-3 md:gap-4">
        <div className="h-9 w-9 rounded-lg bg-teal/10 border border-teal/25 grid place-items-center text-teal shrink-0">
          <Icon size={15} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-1">
            <span className="h-1.5 w-1.5 rounded-full bg-teal pulse-dot" />
            <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground">
              {cell.label}
            </div>
            <div className="ml-auto text-[10px] font-mono text-muted-foreground/70">
              {item.when}
            </div>
          </div>
          <div key={`${cell.key}-${i}`} className="ticker-line">
            <span className={`font-display text-lg md:text-xl font-semibold ${cell.hueClass}`}>
              {item.tag}
            </span>{" "}
            <span className="text-sm text-foreground/85">{item.detail}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default function TrustTicker() {
  return (
    <section
      data-testid="trust-ticker-section"
      className="relative border-t border-white/5 py-8 md:py-10"
    >
      <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 rounded-full bg-teal pulse-dot" />
            <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-teal">
              Live activity · momentum right now
            </div>
          </div>
          <div className="hidden md:block text-[10px] font-mono uppercase tracking-[0.18em] text-muted-foreground">
            Refreshed continuously
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
          {CELLS.map((c, i) => (
            <Cell key={c.key} cell={c} cellIdx={i} />
          ))}
        </div>
      </div>

      <style>{`
        @keyframes tickerIn {
          from { opacity: 0; transform: translateY(6px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .ticker-line {
          animation: tickerIn 500ms cubic-bezier(0.22, 1, 0.36, 1);
        }
        @keyframes sweepX {
          0% { transform: translateX(0); opacity: 0; }
          20% { opacity: 1; }
          100% { transform: translateX(1400%); opacity: 0; }
        }
        .ticker-sweep { animation: sweepX 6s linear infinite; }
      `}</style>
    </section>
  );
}
